import Pages from "layouts/Pages.jsx";
import Dashboard from "layouts/Dashboard.jsx";

var indexRoutes = [
	{ path: "/login", name: "Login", component: Pages },
	{ path: "/", name: "Home", component: Dashboard, auth: true }
];

export default indexRoutes;
